import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 400.73 122.34"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "data-name": "Layer 2" }, [
  /*#__PURE__*/_createElementVNode("g", { "data-name": "Layer 1" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M339 22.67v-1.42A19.25 19.25 0 0 0 319.76 2H53.9a19.25 19.25 0 0 0-19.25 19.25v1.42A19.25 19.25 0 0 0 53.9 41.92h55a19.25 19.25 0 0 1 19.2 19.25v1.42a19.25 19.25 0 0 1-19.25 19.25h-87.6A19.25 19.25 0 0 0 2 101.09a19.25 19.25 0 0 0 19.25 19.25h358.23a19.25 19.25 0 0 0 19.25-19.25 19.25 19.25 0 0 0-19.25-19.25H269.36a19.24 19.24 0 0 1-19.24-18.9v-1.43a19.25 19.25 0 0 1 19.25-19.59h50.42A19.25 19.25 0 0 0 339 22.67Z",
      "data-name": "Clouds",
      style: {"fill":"#fff7f3","stroke":"#2d2d34","stroke-miterlimit":"10","stroke-width":"2px"}
    })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }